import { useMemo } from 'react'

import {
  CubeOperator,
  CubeSchemaTables,
  DRIFT_CHAT_OPPORTUNITY_EVENTS,
} from 'cube'

import {
  CubeQuery,
  CubeQueryBuilder,
  resultSetAsTableData,
  useCubeQuery,
} from '@driftt/dds.reports'

import { OpportunityTimelineBaseQuery } from 'layouts/RevenueReport'

import {
  IOpportunityTimelineTableRow,
  OpportunitiesTableDataResultMetric,
  UseOpportunityTimelineProps,
} from './OpportunityTimeline.types'

export const useOpportunityTimeline = ({
  opportunityId,
}: UseOpportunityTimelineProps) => {
  const opportunityTimelineCubeQuery: CubeQuery = new CubeQueryBuilder({
    query: OpportunityTimelineBaseQuery,
  })
    .withFilters([
      {
        member: DRIFT_CHAT_OPPORTUNITY_EVENTS.OPPORTUNITY_ID,
        operator: CubeOperator.EQUALS,
        values: [opportunityId],
      },
    ])
    .build()

  const { data, isLoading, isError } = useCubeQuery({
    query: opportunityTimelineCubeQuery,
  })

  const opportunitiesData: IOpportunityTimelineTableRow[] = useMemo(() => {
    const tableRows = resultSetAsTableData(
      data
    ) as OpportunitiesTableDataResultMetric[]
    return tableRows.map((row) => {
      return {
        ...row[CubeSchemaTables.DRIFT_CHAT_OPPORTUNITY_EVENTS],
        ...row[CubeSchemaTables.CONVERSATIONS],
        ...row[CubeSchemaTables.PLAYBOOKS],
        playbookName: row[CubeSchemaTables.PLAYBOOKS]?.name,
        endUserEmail:
          row[CubeSchemaTables.DRIFT_CHAT_OPPORTUNITY_EVENTS]?.contactMail,
        endUserDisplayName:
          row[CubeSchemaTables.DRIFT_CHAT_OPPORTUNITY_EVENTS]
            ?.contactDisplayName,
        endUserContactName:
          row[CubeSchemaTables.DRIFT_CHAT_OPPORTUNITY_EVENTS]?.contactName,
        agentDisplayName:
          row[CubeSchemaTables.DRIFT_CHAT_OPPORTUNITY_EVENTS]
            ?.meetingBookedByAgentName,
        messageBody: row[CubeSchemaTables.INTERACTIONS]?.messageBody,
      }
    })
  }, [data])

  return useMemo(
    () => ({
      data: opportunitiesData || [],
      isLoading,
      isError,
    }),
    [opportunitiesData, isError, isLoading]
  )
}
